export default {
  sizes: ["Bayt", "KB", "MB", "GB", "TB", "PB"],
  uploadNoMoreFiles: "Maksimal {maxFileCount} ta fayl yuklang",
  maxFileSize: {
    upppercase: "Gacha {maxFileSize}",
    lowercase: "gacha {maxFileSize}",
  },
  maxUploadFilesAmountWithSize:
    "har biri {maxFileSize} gacha bo‘lgan {maxFilesAmount} ta fayl",
  minMaxUploadFilesAmountWithSize:
    "har biri {size} dan oshmagan {from} dan {to} gacha fayl",
  oneUploadFileWithMaxsize: "1 fayl, maksimal {maxFileSize}",
  newFileAction: {
    moveOr: "Sudrab olib keling yoki",
    upload: "fayllarni yuklang",
  },
  validation: {
    maxSize: "Fayl hajmi maksimal qiymatdan oshdi",
    unsupportedFileType: "Qo‘llab-quvvatlanmagan fayl formati",
    addedUnsupportedFiles: "Qo‘llab-quvvatlanmagan fayllar qo‘shildi",
    totalSizeNotMoreThan: "Fayllar jami hajmi {totalSize} dan oshmasligi kerak",
    exceedFilesAmountLimit:
      "Yuklanadigan fayllar soni bo‘yicha cheklov oshib ketdi",
  },
  uploadPhoto: "Rasm yuklash",
  photoAspect: "Rasm nisbati — {aspect}",
  pictureEditing: "Rasmlarni tahrirlash",
  selectedAreaWillDisplay:
    "Tanlangan maydon RC PAYda sizning joyingizni ko‘rsatishda aks etadi.",
  currentImageFrom: "{total} ta rasmdan {from}-rasm",
};
